module.exports = __webpack_public_path__ + "static/assets/b859e8c3cc92d9c4421e5c8b4aa4fada.png";